export const decode = (str) => decodeURIComponent(str).replace(/\+/g, ' ')

export const findElementAsync = async (selector, interval = 500, maxAttempts = 20) => {
  let i
  let attempts = 0

  return new Promise((resolve, reject) => {
    i = setInterval(() => {
      attempts++
      const el = document.querySelector(selector)

      if (el) {
        clearInterval(i)
        resolve(el)
      }

      if (attempts >= maxAttempts) {
        clearInterval(i)
        reject(new Error('Element not found!'))
      }
    }, interval)
  })
}

export const getUrlParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search)
  const encodedValue = urlParams.get(name)
  if (encodedValue !== null) return decodeURIComponent(encodedValue)
  return null
}

export const setUrlParam = (name, value) => {
  const encodedValue = encodeURIComponent(value)
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.set(name, encodedValue)
  window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`)
}

export const removeUrlParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.delete(name)
  const baseUrl = `${window.location.pathname}?`
  const newUrl = urlParams.toString() ? `${baseUrl}${urlParams.toString()}` : window.location.pathname
  window.history.replaceState({}, '', newUrl)
}

export const setItemWithExpiration = (key, value, expirationDate) => {
  const item = {
    value: value,
    expirationDate: expirationDate.getTime(),
  }
  localStorage.setItem(key, JSON.stringify(item))
}

export const getItemWithExpiration = (key) => {
  const itemString = localStorage.getItem(key)
  if (!itemString) {
    return null
  }

  const item = JSON.parse(itemString)
  const now = Date.now()
  
  if (now > item.expirationDate) {
    localStorage.removeItem(key)
    return null
  }

  return item.value
}

export const graphQLRequest = async (query, variables) => {
  const accessToken = 'ece38201281b8e1d59a8085852224a25'
  const endpoint = '/api/2023-10/graphql.json'
  let data = []

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'x-shopify-storefront-access-token': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify({ query, variables }),
    })
    data = await response.json()
  } catch (error) {
    throw new Error(error)
  }

  return data
}

export const range = (start, end) => {
  let length = end - start + 1
  return Array.from({ length }, (_, idx) => idx + start)
}

export const removeItemFromStringArr = (inputString, itemToRemove) => {
  const items = inputString.split(',')
  const filteredItems = items.filter(item => item !== itemToRemove)
  const newString = filteredItems.join(',')
  return newString
}

export const addItemToStringArrIfNotExists = (inputString, itemToAdd) => {
  const items = inputString.split(',')
  if (!items.includes(itemToAdd)) items.push(itemToAdd)
  const newString = items.join(',')
  return newString
}

export const capitalize = (str) => str.replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase())

export const handleize = str => str.replace(/[ /_]/g, '-').toLowerCase()

